import { CrmContext, CrmContextProvider, useCrmContext, withCrmContext, useAttribute } from './src/contexts/crm-context'

export * from './src/permissions'
export * from './src/bulk-operations/bulk-operations-context'

export { CrmContext, CrmContextProvider, useCrmContext, withCrmContext, useAttribute }
